<template>
  <div
    class="carousel"
    :class="{'game-type': gameLobby}"
  >
    <VueSlickCarousel v-if="carousel.length !== 0" class="carousel slider index-slick" v-bind="slick_setting" :arrows="false">
      <a
        v-for="(item, key) in carousel"
        :key="key"
        class="d-block"
        @click="goLink(isMobile() ? item.link : item.pc_link, item.open_type)"
      >
        <img
          :src="isMobile() ? item.image : item.pc_image"
          :alt="isMobile() ? item.link : item.pc_link"
        >
      </a>
    </VueSlickCarousel>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import { detectMob } from '@/utils/tool'

export default {
  components: {
    VueSlickCarousel
  },
  data() {
    return {
      carousel: [],
      slick_setting: {
        pauseOnHover: true,
        adaptiveHeight: false,
        dots: true,
        infinite: true,
        draggable: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        initialSlide: 0,
        fade: true,
        cssEase: 'linear'
      }
    }
  },
  computed: {
    brand() {
      return this.$store.state.brand
    },
    user() {
      return this.$store.state.user
    },
    currentGameCategory() {
      return this.user.currentGameCategory
    },
    currentGameType() {
      return this.user.currentGameType
    },
    currentGameProvider() {
      return this.user.currentGameProvider
    },
    activeFilter() {
      return this.user.activeFilter
    },
    gameLobby() {
      return this.brand.showSearch || this.brand.showProvider ||
      this.currentGameCategory || this.currentGameType || this.currentGameProvider ||
      this.activeFilter === 'favorites'
    }
  },
  watch: {
    '$store.state.brand.carousel': {
      handler(newVal) {
        if (newVal) {
          this.carousel = newVal
        }
      },
      immediate: true
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.brand.carousel.length) {
        this.carousel = this.brand.carousel
      }
    })
  },
  methods: {
    isMobile() {
      return detectMob()
    },
    goLink(link, open_type) {
      if (link === 'pop_register') {
        this.$store.commit('SET_REGISTER_OPEN', true)
      } else {
        window.open(link, open_type)
      }
    }
  }
}
</script>

<style>
.slick-dots {
  bottom: 10px;
}

.index-slick .slick-slide {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity 1s cubic-bezier(.19,1,.22,1), transform 2s cubic-bezier(.19,1,.22,1);
}
.index-slick .slick-slide.slick-current {
  opacity: 1;
  z-index: 1;
}
.index-slick .slick-dots li button::before {
  opacity: 1;
  color: #fff;
  width: 15px;
  height: auto;
  font-size: 12px;
  transform: scale(.8);
  opacity: .8;
  transition: 1.6s cubic-bezier(.19,1,.22,1);
  cursor: pointer;
}

.index-slick .slick-dots li.slick-active button:before {
  color: #b1a781;
  transform: scale(1);
  opacity: 1;
}

.index-slick .slick-slide a {
  position: relative;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
}
.index-slick .slick-slide a img {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transform: scale(1.4);
  opacity: 0;
  transition: opacity 1s cubic-bezier(.19,1,.22,1),transform 2s cubic-bezier(.19,1,.22,1);
}
.index-slick  .slick-slide.slick-active a img {
    transform: scale(1);
    opacity: 1;
}

@media only screen and (max-width: 992px) {
  .index-slick .slick-slide a img {
    max-height: 516px;
  }
}

@media only screen and (max-width: 500px) {
  .index-slick .slick-slide a img {
      width: 100%;
      max-height: 350px;
  }
}
</style>
